import React from 'react';
import * as innerRoutes from './user_group_route_util';
import AllUserGroupsComponent from "./AllUserGroups";
import UserGroupUsersComponent from "./UserGroupUsers";
import {Route} from "react-router-dom";

class UserGroupsComponent extends React.Component {
  render() {
    return(
      <div>
        <switch>
          <Route exact path={innerRoutes.inner_route_tags_user_groups} component={AllUserGroupsComponent}/>
          <Route path={innerRoutes.inner_route_tags_user_groups_users} component={UserGroupUsersComponent}/>
        </switch>
      </div>
    )
  }
}

export default UserGroupsComponent;
